module.exports = __webpack_public_path__ + "static/media/Tangeebl_logo.5fac4717.svg";